import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen" }
const _hoisted_2 = { class: "max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_3 = { class: "text-2xl font-bold text-gray-900 mb-6" }
const _hoisted_4 = { class: "bg-white rounded-xl shadow-sm border border-gray-200 p-6 space-y-4" }
const _hoisted_5 = { class: "text-lg font-semibold text-gray-900 mb-2" }
const _hoisted_6 = { class: "text-sm text-gray-600" }
const _hoisted_7 = { class: "mt-3 text-sm text-gray-600 list-decimal list-inside space-y-2" }
const _hoisted_8 = { class: "text-lg font-semibold text-gray-900 mb-2" }
const _hoisted_9 = { class: "text-sm text-gray-600" }
const _hoisted_10 = { class: "mt-2 text-sm text-gray-600 list-disc list-inside space-y-1" }
const _hoisted_11 = { class: "text-lg font-semibold text-gray-900 mb-2" }
const _hoisted_12 = { class: "text-sm text-gray-600" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavBar"], {
      "signed-in": $props.signedIn,
      "user-name": $props.userName,
      "active-page": ""
    }, null, 8 /* PROPS */, ["signed-in", "user-name"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString($setup.t('data_deletion.title')), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("section", null, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString($setup.t('data_deletion.how_title')), 1 /* TEXT */),
          _createElementVNode("p", _hoisted_6, _toDisplayString($setup.t('data_deletion.how_text')), 1 /* TEXT */),
          _createElementVNode("ol", _hoisted_7, [
            _createElementVNode("li", null, _toDisplayString($setup.t('data_deletion.step_1')), 1 /* TEXT */),
            _createElementVNode("li", null, _toDisplayString($setup.t('data_deletion.step_2')), 1 /* TEXT */),
            _createElementVNode("li", null, _toDisplayString($setup.t('data_deletion.step_3')), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("section", null, [
          _createElementVNode("h2", _hoisted_8, _toDisplayString($setup.t('data_deletion.what_title')), 1 /* TEXT */),
          _createElementVNode("p", _hoisted_9, _toDisplayString($setup.t('data_deletion.what_text')), 1 /* TEXT */),
          _createElementVNode("ul", _hoisted_10, [
            _createElementVNode("li", null, _toDisplayString($setup.t('data_deletion.data_profile')), 1 /* TEXT */),
            _createElementVNode("li", null, _toDisplayString($setup.t('data_deletion.data_messages')), 1 /* TEXT */),
            _createElementVNode("li", null, _toDisplayString($setup.t('data_deletion.data_comments')), 1 /* TEXT */),
            _createElementVNode("li", null, _toDisplayString($setup.t('data_deletion.data_runs')), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("section", null, [
          _createElementVNode("h2", _hoisted_11, _toDisplayString($setup.t('data_deletion.contact_title')), 1 /* TEXT */),
          _createElementVNode("p", _hoisted_12, _toDisplayString($setup.t('data_deletion.contact_text')), 1 /* TEXT */),
          _cache[0] || (_cache[0] = _createElementVNode("p", { class: "text-sm text-blue-700 mt-1" }, "admin@alerg.eu", -1 /* CACHED */))
        ])
      ])
    ])
  ]))
}